export enum FilterType {
  NumberRange = "NumberRange",
  Select = "Select",
}
